import React from "react";

// export { default as CompanyLocation } from "./companyLocation/CompanyLocation";
export const CompanyLocation = React.lazy(() =>
  import("./companyLocation/CompanyLocation")
);

// export { default as Department } from "./department/Department";
export const Department = React.lazy(() => import("./department/Department"));

// export { default as Designation } from "./designation/Designation";
export const Designation = React.lazy(() =>
  import("./designation/Designation")
);
// export { default as WorkPrimise } from "./workPrimise/WorkPrimise";
export const WorkPrimise = React.lazy(() =>
  import("./workPrimise/WorkPrimise")
);

// export { default as EmployeeType } from "./emplayeeType/EmployeeType";
export const EmployeeType = React.lazy(() =>
  import("./employeeType/EmployeeType")
);

// export { default as Reward } from "./reward/Reward";
export const Reward = React.lazy(() => import("./reward/Reward"));

// export { default as LeaveType } from "./leaveType/LeaveType";
export const LeaveType = React.lazy(() => import("./leaveType/LeaveType"));
export const YearEndProcess = React.lazy(() => import("./YearEndProcess/YearEndProcess"));
// export { default as HolidayCalender } from "./holidayCalender/HolidayCalender";
export const HolidayCalender = React.lazy(() =>
  import("./holidayCalender/HolidayCalender")
);

// export { default as CompanyPolicy } from "./companyPolicy/CompanyPolicy";
export const CompanyPolicy = React.lazy(() =>
  import("./companyPolicy/CompanyPolicy")
);

// export { default as RolesNdPermissions } from "./rolesNdPermissions/RolesNdPermissions";
export const RolesNdPermissions = React.lazy(() =>
  import("./rolesNdPermissions/RolesNdPermissions")
);

// export { default as Assets } from "./assets/Assets";
export const Assets = React.lazy(() => import("./assets/Assets"));

// export { default as SkillCategory } from "./skillcategory/SkillCategory";
export const SkillCategory = React.lazy(() => import("./SkillCategory/SkillCategory"));

// export { default as Skills } from "./skills/skills";
export const Skills = React.lazy(() => import("./skills/skills"));

// export { default as Certifications } from "./certifications/certifications";
export const Certifications = React.lazy(() => import("./certifications/certifications"));

// export { default as Technologies } from "./technologies/technologies";
export const Technologies = React.lazy(() => import("./technologies/technologies"));

// export { questionsforappraisee } from "./AppraisalSetting/questionsforappraisee";
export const Questionsforappraisee = React.lazy(() => import("./AppraisalSetting/Questionsforappraisee"));

// export { reviewratingforappraisee } from "./ReviewRating/reviewrating";
export const ReviewRatingforApprisal = React.lazy(() => import("./ReviewRating/reviewrating"));

// export { attributeforappraisee } from "./attributes/attribute";
export const BehavioralAttributeforApprisal = React.lazy(() => import("./attribute/attribute"));

// export { Potential } from "./potential/potential";
export const Potential = React.lazy(() => import("./potential/potential"));

// export PrimaryGoals from AppraisalSetting/PrimaryGoal

export const PrimaryGoals = React.lazy(()=>import("./AppraisalSetting/PrimaryGoals"));



export const AssignLeave=React.lazy(() => import("./AssignLeave/AssignLeave"));

export const ConfigureMail=React.lazy(() => import("./ConfigureMail/ConfigureMail"));

export const ConfigureMailForLeave =React.lazy(() => import("./ConfigureMailForLeave/ConfigureMailForLeave"));
export const AutoLOPConfig = React.lazy(() => import("./AutoLOPConfig/AutoLOPConfig"));
export const AutoLOPWarningConfig = React.lazy(() => import("./AutoLOPWarningConfig/AutoLOPWarningConfig"));
export const TimesheetAutoLockConfig = React.lazy(() => import("./TimesheetAutoLockConfig/TimesheetAutoLockConfig"));
export const WeeklyTimesheetReminderConfig = React.lazy(() => import("./WeeklyTimesheetReminderConfig/WeeklyTimesheetReminderConfig"));